






import PartnerManageStepper from "@/components/partner/PartnerManageStepper.vue";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { Component, Vue } from "vue-property-decorator";
import { ManageStepperDescriptionTypes } from "@/store/enum/partner/manage-stepper-description-type.enum";
import { ManageStepperScreenTypes } from "@/store/enum/partner/manage-stepper-screen-types.enum";
import { ManageStepperEnum } from "@/store/enum/partner/manage-stepper.enum";
import { ManageStepperSetupSetting } from "@/lib/interfaces/partner/partnerManageStepperSetupSetting.interface";
import { IPartnerManageStepperStep } from "@/lib/interfaces/partner/partnerManageStepperStep.interface";
import { SettingModule } from "@/store/modules/setting.store";
import { emailRule } from "@/lib/rules/contactRule";
import { PdrSettingsKeys } from "@/store/enum/manage/pdr-setting-keys.enum";
import { requiredRule } from "@/lib/rules/requiredRule";

@Component({
  components: {
    PartnerManageStepper,
    LayoutSimple
  }
})
export default class PartnerManageStepperPDRView extends Vue {
  mounted() {
    SettingModule.clearPartnerSetting();
  }

  /**
   * steps of DA Stepper
   */
  get steps(): IPartnerManageStepperStep[] {
    return [
      {
        type: ManageStepperScreenTypes.DESCRIPTION,
        descriptionType: ManageStepperDescriptionTypes.PDR_SETUP_ASSISTANT
      },
      { type: ManageStepperScreenTypes.SETUP, setupSettings: this.pdrSetupSettings, context: ManageStepperEnum.PDR },
      { type: ManageStepperScreenTypes.CREDENTIALS, context: ManageStepperEnum.PDR },
      { type: ManageStepperScreenTypes.DESCRIPTION, descriptionType: ManageStepperDescriptionTypes.END }
    ];
  }

  /**
   * settings that are used in DA setup step
   */
  get pdrSetupSettings(): ManageStepperSetupSetting[] {
    return [
      {
        key: PdrSettingsKeys.EMAIL,
        value: "",
        rules: [emailRule(), requiredRule()]
      },
      {
        key: PdrSettingsKeys.PASSWORD,
        value: ""
      }
    ];
  }
}
